<template>
  <div style="background:#f3f3f3;">
      <div class="wapper overf" >
	<div class="part">
       <img src="../../static/img/banner.png" width="100%"  />
	</div>
</div>

<div class="wapper overf">
	<div class="part main-box2" style="background:#fff; padding:50px;">
        
        <div class="tit3"><em><a @click="goHome">返回首页>>  </a></em><span>我要举报</span></div>
        <div class=" t-center m_t_50">
              <a @click="notice('1018')" ><div class="button button-large szbk" style="background:url(static/img/sz_btn_bk.png) left top no-repeat; width:240px; height:110px; " >省委组织部<br />12380举报网站</div></a>
        </div>
        <div id="sz_btn">
              <a @click="notice('1018001','长沙市')" > <div class="button button-large szbk"  >长沙市委组织部<br />12380举报网站</div></a>
              <a @click="notice('1018004','衡阳市')" > <div class="button button-large szbk"  >衡阳市委组织部<br />12380举报网站</div></a>
              <a @click="notice('1018002','株洲市')" > <div class="button button-large szbk"  >株洲市委组织部<br />12380举报网站</div></a>
              <a @click="notice('1018003','湘潭市')" > <div class="button button-large szbk"  >湘潭市委组织部<br />12380举报网站</div></a>
              <a @click="notice('1018005','邵阳市')" > <div class="button button-large szbk"  >邵阳市委组织部<br />12380举报网站</div></a>
              <a @click="notice('1018006','岳阳市')" > <div class="button button-large szbk"  >岳阳市委组织部<br />12380举报网站</div></a>
              <a @click="notice('1018007','常德市')" > <div class="button button-large szbk"  >常德市委组织部<br />12380举报网站</div></a>
              <a @click="notice('1018008','张家界市')" > <div class="button button-large szbk"  >张家界市委组织部<br />12380举报网站</div></a>
              <a @click="notice('1018009','益阳市')" > <div class="button button-large szbk"  >益阳市委组织部<br />12380举报网站</div></a>
              <a @click="notice('1018010','郴州市')" > <div class="button button-large szbk"  >郴州市委组织部<br />12380举报网站</div></a>
              <a @click="notice('1018011','永州市')" > <div class="button button-large szbk"  >永州市委组织部<br />12380举报网站</div></a>
              <a @click="notice('1018012','怀化市')" > <div class="button button-large szbk"  >怀化市委组织部<br />12380举报网站</div></a>
              <a @click="notice('1018013','娄底市')" > <div class="button button-large szbk"  >娄底市委组织部<br />12380举报网站</div></a>
              <a @click="notice('1018014','湘西自治州')" > <div class="button button-large szbk"  >湘西自治州委组织部<br />12380举报网站</div></a>
        </div>
    </div>
</div>

<div class="clear overf m_t_40"></div>
<!---- foot ---->
<div class="wapper overf p_b_10" style="background:#AD0C1D;" >
  <div class="part p_t_20 h26 cWhite f14 overf" >
	  <div class="t-center">	
            <p class=" p_l_10 ">
                Copyright© 2010.中共湖南省委组织部举报中心 All Rights Reserved 
			</p>
      <p class=" p_l_10 ">
    备案号：<a href="http://beian.miit.gov.cn/" target="_blank">湘ICP备17016663号-2</a>
                </p>
     </div>
</div>
</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods:{
      notice(code,cityName){
        if (code=='1018'){
          this.$router.push({name:'notice',query:{areaCode:code}}) 
        }else{
          this.$router.push({name:'county',query:{areaCode:code,areaName:cityName},params:{areaCode:code,areaName:cityName}})
        }
      },
      goHome(){
          this.$router.push({name:'index'})
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#sz_btn{ width:90%; display:block; margin:0 auto; text-align:center;}
#sz_btn a{ display:inline-block; margin:25px; }
#sz_btn .szbk{background: url(../../static/img/sz_btn_bk2.png) left top no-repeat; width:185px; height:85px; line-height:30px; font-size:16px; color:#333; padding:8px 0;}
#sz_btn a:hover .szbk{ color:#fff; background:url(../../static/img/xq_btn_bk2.png) left top no-repeat;}

</style>



// WEBPACK FOOTER //
// src/views/area.vue